import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_BANK_WISE_DEPOSIT_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getDataListing = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/BankDeposit/GetDLMWiseBankDepositReport`, postedData)
    .then(({ data }) => {
      // ;
      dispatch({
        type: GET_BANK_WISE_DEPOSIT_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const { data } = await axios.post(
      `api/BankDeposit/GetDLMWiseBankDepositReport`,
      requestData,
    );

    const outputFilename = `Bank_wise_Deposit_Report_${Date.now()}`;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Only include selected columns
    const selectedColumns = [
      "distributor",
      "distributionCenter",
      "deliverymanName",
      "dlmTillNo",
      "cashCollected",
      "bankDeposit",
      "depositDate",
      "bankName",
      "accountNumber",
      "accountTitle",
      "despoitSlipNumber",
      "remainingCashinHand",
    ];

    const exportData = (dataArray) => {
      // Map data to only selected columns
      const filteredData = dataArray.map((row) => {
        const filteredRow = {};
        selectedColumns.forEach((col) => {
          filteredRow[col] = row[col] ?? ""; // default to empty string if null
        });
        return filteredRow;
      });

      const ws = XLSX.utils.json_to_sheet(filteredData);
      const wb = {
        Sheets: { data: ws },
        SheetNames: ["data"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fileData = new Blob([excelBuffer], { type: fileType });
      // ;
      fileSaver.saveAs(fileData, outputFilename + fileExtension);
    };

    exportData(data?.response?.data ?? []);
    dispatch(hideLoading());
  } catch (error) {
    dispatch(hideLoading());
    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
      } else if (error.response.data) {
        toast.error(error.response.data.Message || error.response.data.message);
      } else {
        toast.error("Error while processing the request");
      }
    }
  }
};
